var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddRequest = function SvgAddRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 13.333,
    fill: "#F55F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF3EB",
    d: "M16 2.667A13.333 13.333 0 1 0 29.333 16 13.35 13.35 0 0 0 16 2.667m5.128 14.359h-4.102v4.102a1.025 1.025 0 1 1-2.052 0v-4.102h-4.102a1.026 1.026 0 1 1 0-2.052h4.102v-4.102a1.026 1.026 0 0 1 2.052 0v4.102h4.102a1.025 1.025 0 1 1 0 2.052"
  })));
};
export default SvgAddRequest;